import { ReactNode } from 'react'
import { classNames } from '@/util/tailwindHelpers'
import { ARCADE_BADGE_TYPES } from '@/enum'
import Badge, { BadgeProps } from '.'
import useBreakpoints from '@/hooks/useBreakpoints'
import { ArcadeBadgeType } from '@/features/arcade/types'
import { arcadeBadgeIcon } from '@/features/arcade/constants'
interface Props extends BadgeProps {
  type: ArcadeBadgeType
  label: ReactNode
  layout?: 'full' | 'auto'
  useCase?: 'nav' | 'leaderboard'
}

const ArcadeBadge = ({
  type,
  label,
  className,
  layout = 'auto',
  useCase = 'nav',
  ...props
}: Props) => {
  const { isMobile } = useBreakpoints()
  const icon = arcadeBadgeIcon(type)
  const isFullLayout = layout === 'full'

  const getIconStyles = () => {
    switch (type) {
      case ARCADE_BADGE_TYPES.Start:
        return '!w-[23px] !h-[23px] md:!w-[21px] md:!h-[21px]'
      default:
        return '!w-[21px] !h-[21px] md:!w-2 md:!h-2'
    }
  }

  const baseClasses =
    useCase === 'leaderboard'
      ? 'h-[40px] w-[40px] md:h-auto md:w-auto !px-[5.5px]'
      : 'h-[40px] w-[40px] md:h-4 md:w-4 !px-0 py-0 md:!px-[5.5px]'

  return (
    <Badge
      className={classNames(
        baseClasses,
        'flex items-center justify-center border-[currentColor] border-[1.5px]',
        '[&_span]:pricing [&_span]:!text-[14px] [&_span]:text-white',
        {
          'text-arcadeGreen': type === ARCADE_BADGE_TYPES.Eligible,
          'text-gray-300': type === ARCADE_BADGE_TYPES.Ineligible,
          'tabular-nums border-arcadeGreen': type === ARCADE_BADGE_TYPES.Start,
          'md:w-auto md:!pr-[10px] md:!pl-[9px]': !isFullLayout,
          'w-auto !pr-[10px] !pl-[9px]': isFullLayout
        },
        className
      )}
      label={label}
      icon={icon}
      iconClass={classNames('!mr-auto m-auto', getIconStyles(), {
        'md:!mr-[6px]': !isFullLayout,
        '!mr-[6px]': isFullLayout
      })}
      hideLabel={isFullLayout ? false : isMobile}
      {...props}
    />
  )
}

export default ArcadeBadge
